import { render, staticRenderFns } from "./SoilTypeList.vue?vue&type=template&id=0db8b0ed&scoped=true&"
import script from "./SoilTypeList.vue?vue&type=script&lang=js&"
export * from "./SoilTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8b0ed",
  null
  
)

export default component.exports